import {
  SimpleGrid,
  Image,
  Flex,
  Text,
  Box,
  GridItem,
  Input,
  Icon,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { FaSquareXTwitter } from "react-icons/fa6";
import { FaInstagram, FaLinkedin } from "react-icons/fa";

import { Button } from "./ui/button";

import Logo2 from "../assets/images/logo2.png";

export const Footer = () => {
  return (
    <Box
      px={{ base: "16px", md: "70px", "2xl": 0 }}
      py={{ base: "48px", md: "64px" }}
      bg="#0D1E21"
    >
      <Box maxW={{ base: "100%", "2xl": "1300px" }} mx="auto">
        <SimpleGrid
          columns={{ base: 1, md: 2 }}
          gap={{ base: "20px", md: "56px" }}
          alignItems={"center"}
        >
          <Box>
            <Text
              fontSize={{ base: "23px", md: "48px" }}
              fontWeight={500}
              color={"#F8F9FA"}
              fontFamily={"DMSans-Medium"}
            >
              Stay in the know
            </Text>

            <Text
              fontSize={{ base: "14px", md: "19px" }}
              color={"#EBF0F0"}
              fontFamily={"Sora-Regular"}
            >
              Stay connected. Follow us on social media and subscribe to our
              newsletter to receive the latest news, success stories, and event
              updates
            </Text>
          </Box>

          <Flex
            justifyContent={{ base: "flex-start", md: "flex-end" }}
            display={{ base: "block", md: "flex" }}
          >
            <Flex
              gap={{ base: "24px", md: "16px" }}
              mt="40px"
              mb="8px"
              flexDir={{ base: "column", md: "row" }}
            >
              <Input
                type="email"
                // value={email}
                // onChange={(event) => setEmail(event.target.value)}
                placeholder="Enter your email"
                variant="outline"
                bg="#EBF0F0"
                borderColor={"#E8E9EA"}
                _placeholder={{
                  color: "#616161",
                }}
                color={"#616161"}
                borderRadius={"8px"}
                h={"50px"}
                w={{ base: "100%", md: "280px" }}
                _hover={{
                  borderColor: "#003366",
                  transform: "scale(1.03)",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                }}
                _focus={{
                  borderColor: "#003366",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                }}
                transition="all 0.2s ease-in-out"
                fontFamily={"Sora-Regular"}
                fontSize={"16px"}
              />

              <Button borderRadius={"8px"} h={"52px"}>
                Subscribe
              </Button>
            </Flex>
          </Flex>
        </SimpleGrid>

        <Box px={{ base: 0, md: "42px" }} fontFamily={"Sora-Regular"}>
          <Box h="1px" bg="#475467" my="64px"></Box>

          <Flex
            gap={"64px"}
            justify={"space-between"}
            px={"16px"}
            display={{ base: "block", md: "flex" }}
          >
            <Box display={{ base: "none", md: "block" }}>
              <Image src={Logo2} h={"30px"} />

              <Text my="32px" fontSize={"16px"} color={"white"} w={"70%"}>
                Bridging Research and Impact Investments
              </Text>

              <Flex gap={"24px"}>
                <Icon size={"lg"} color={"#98A2B3"}>
                  <FaLinkedin />
                </Icon>

                <Icon size={"lg"} color={"#98A2B3"}>
                  <FaInstagram />
                </Icon>

                <Icon size={"lg"} color={"#98A2B3"}>
                  <FaSquareXTwitter />
                </Icon>
              </Flex>
            </Box>

            <Image
              src={Logo2}
              h={"30px"}
              display={{ base: "block", md: "none" }}
              mb="32px"
            />

            <SimpleGrid gap={"64px"} columns={{ base: 2, md: 3 }}>
              <GridItem colSpan={1}>
                <Text
                  fontSize={"16px"}
                  fontWeight={500}
                  color={"#98A2B3"}
                  mb="16px"
                >
                  Company
                </Text>

                <Link to="/story">
                  <Text
                    fontSize={"16px"}
                    fontWeight={500}
                    color={"#EAECF0"}
                    mb="12px"
                  >
                    Our story
                  </Text>
                </Link>

                <Link to="/approach">
                  <Text
                    fontSize={"16px"}
                    fontWeight={500}
                    color={"#EAECF0"}
                    mb="12px"
                  >
                    Our approach
                  </Text>
                </Link>
              </GridItem>

              <GridItem colSpan={1}>
                <Text
                  fontSize={"16px"}
                  fontWeight={500}
                  color={"#98A2B3"}
                  mb="16px"
                >
                  Resources
                </Text>

                <Link to="/faq">
                  <Text
                    fontSize={"16px"}
                    fontWeight={500}
                    color={"#EAECF0"}
                    mb="12px"
                  >
                    FAQs
                  </Text>
                </Link>

                <Link to="/contact">
                  <Text
                    fontSize={"16px"}
                    fontWeight={500}
                    color={"#EAECF0"}
                    mb="12px"
                  >
                    Get involved
                  </Text>
                </Link>
              </GridItem>

              <GridItem colSpan={1}>
                <Text
                  fontSize={"16px"}
                  fontWeight={500}
                  color={"#98A2B3"}
                  mb="16px"
                >
                  Socials
                </Text>

                <Text
                  fontSize={"16px"}
                  fontWeight={500}
                  color={"#EAECF0"}
                  mb="12px"
                >
                  LinkedIn
                </Text>

                <Text
                  fontSize={"16px"}
                  fontWeight={500}
                  color={"#EAECF0"}
                  mb="12px"
                >
                  Instagram
                </Text>

                <Text
                  fontSize={"16px"}
                  fontWeight={500}
                  color={"#EAECF0"}
                  mb="12px"
                >
                  X
                </Text>
              </GridItem>
            </SimpleGrid>
          </Flex>

          <Box h="1px" bg="#475467" mt="64px" mb="32px"></Box>

          <Text fontSize={"16px"} color={"#98A2B3"}>
            © 2025 Motiv.
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
